import http from '@/utils/http';

export default {
  async getById(id) {
    return await http.get(`/api/user_location_history/get/${id}`);
  },
  async insert(data) {
    return await http.post('/api/user_location_history/insert', data);
  },
  async update(data) {
    return await http.post('/api/user_location_history/update', data);
  },
  async delete(data) {
    return await http.post('/api/user_location_history/delete', data);
  },
  async getHistory(id_user) {
    return await http.get(`/api/user_location_history/get-history/${id_user}`);
  }
};